import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import { Link } from 'react-router-dom'
import naturalCompare from 'natural-compare'
import _ from 'lodash'

import {
  Button,
  Grid,
  Notifications,
  Table,
  Loading,
} from 'components/UI'
import OrganizationFilter from './OrganizationFilter'

class BuildingList extends Component {
  state = {
    organizationFilter: [],
    filterPopupOpen: false,
  }

  handleFilterSubmit = organizationFilter => {
    this.setState({
      organizationFilter,
    })
  }

  handleFilterClose = () => {
    this.setState({
      filterPopupOpen: false,
    })
  }

  handleFilterOpen = () => {
    this.setState({
      filterPopupOpen: true,
    })
  }
    
  render () {
    const {
      error,
      loading,
      buildings,
    } = this.props.data

    const {
      organizationFilter,
      filterPopupOpen,
    } = this.state

    if (error) return <Notifications.Error message={error.message} />

    const columns = [{
      Header: 'Building Name',
      id: 'name',
      accessor: item => ({ id: item.id, name: item.name }),
      Cell: ({ value }) => (
        <Link to={`/buildings/${value.id}`}>
          {value.name}
        </Link>
      ),
      sortMethod: (a, b) => naturalCompare(a.name, b.name),
    }, {
      Header: 'No. of Floors',
      accessor: 'floorCount',
      maxWidth: 150,
    }, {
      Header: 'No. of Apts',
      accessor: 'unitCount',
      maxWidth: 150,
    }, {
      Header: 'Piping System',
      accessor: 'pipingSystems',
    }, {
      Header: 'Alert Count',
      accessor: 'alertCount',
      maxWidth: 150,
    }]

    const usingFilters = organizationFilter.length > 0
    const filteredBuildings = usingFilters ? _.filter(buildings, building => (
      _.includes(organizationFilter, building.organization.id)
    )) : buildings

    return (
      <Grid>
        <Grid.Row>
          <Button
            big
            onClick={this.handleFilterOpen}
          >
            Select Organization {usingFilters ? `(${organizationFilter.length})` : ''}
          </Button>
          { filterPopupOpen &&
            <OrganizationFilter
              onSubmit={this.handleFilterSubmit}
              onClose={this.handleFilterClose}
              selection={organizationFilter}
            />
          }
        </Grid.Row>
        <Grid.Row>
          { loading ? <Loading /> :
            <Table
              data={filteredBuildings}
              columns={columns}
            />
          }
        </Grid.Row>
      </Grid>
    )
  }
}

export default graphql(gql`
  query BuildingListQuery {
    buildings {
      id
      name
      floorCount
      unitCount
      alertCount
      pipingSystems
      organization {
        id
      }
    }
  }
`, {
  options: { notifyOnNetworkStatusChange: true },
})(BuildingList)



// WEBPACK FOOTER //
// ./src/components/Building/BuildingList.jsx